
import {EDIT_ERROR_ERROR} from "../../../reducers/editErrorReducer";


export const editErrorError = (error) =>{
    return {
        type: EDIT_ERROR_ERROR,
        payload: {error}
    }
}